import React from "react";

const LoadingSpinner = () => {
  return (
    <section className="position-absolute top-50 start-50 translate-middle">
      <div className="d-flex flex-column align-items-center">
        <strong className="pb-5">
          Fetching stake rewards. This might take some time.
        </strong>
        <div
          className="spinner-border text-light mx-2 d-flex flex-column justify-content-center"
          role="status"
          style={{ width: "5rem", height: "5rem" }}
        ></div>
      </div>
    </section>
  );
};
export default LoadingSpinner;
